<template>
    <img :src="logoSrc" alt="802 Spirits" class="spirits802-wordmark" />
</template>

<script>
import logo from './802SpiritsWordmark.png'

export default {
    name: 'spirits802Logo',
    data() {
        return {
            logoSrc: logo,
        }
    },
}
</script>

<style scoped>
.spirits802-wordmark {
    width: 100px;
    height: auto;
    display: block;
}
</style>
